module.exports = __webpack_public_path__ + "img/car-dash.6621a653.png";